<template>
  <div>
    <el-dialog :title="detailTitle" :visible.sync="CUFlag" v-if="CUFlag" :close-on-click-modal="false">
      <div style="height: 35px;color: #333333;font-weight: bold;">
        <span>审核进度</span>
      </div>
      <div class="block">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon"
            :type="activity.type" :color="activity.color" :size="activity.size" :timestamp="activity.auditDate == null
                ? ''
                : activity.auditDate + '\u3000' + activity.auditContent
              ">
            {{ activity.auditUserName }}
          </el-timeline-item>
        </el-timeline>
      </div>

      <div v-if="isAudit">
        <el-form :model="ruleForm" ref="rForm" label-width="100px" class="ruleForm" :rules="rules">
          <el-form-item label="审核意见：" prop="auditSchedule">
            <el-radio-group v-model="ruleForm.auditSchedule" @change="auditScheduleChange">
              <el-radio v-for="(item, i) in auditScheduleAttr" :key="i" :label="item.paramKey">
                {{ item.paramValue }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.auditSchedule === '3'" label="转交人：" prop="auditUserId">
            <el-input v-model="ruleForm.auditUserId" v-show="false"></el-input>
            <el-input style="width: 30%" placeholder="请选择转交人" v-model="ruleForm.auditUserName" readonly></el-input>
            <el-button class="button-dept" @click="selectAuditor">选择</el-button>
          </el-form-item>
          <el-form-item label="意见说明：" prop="auditContent">
            <el-input type="textarea" placeholder="请输入意见说明" :row="3" v-model="ruleForm.auditContent"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="isAudit" slot="footer" class="dialog-footer">
        <butn @click.native="closeFrom()" btntype title="取消"></butn>
        <butn btntype="primary" @click.native="updateForm()" title="确定" v-permission="'resource:audit:update'"></butn>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import { auditHistoryList, auditHistoryUpdate } from "@/api/videoAudit";
import { getDataMap } from "@/api/sysParam";

export default {
  components: { butn },
  data() {
    return {
      size: "small",
      ruleForm: {
        auditSchedule: "2",
        auditUserId: "",
        auditUserName: "",
        auditContent: ""
      },
      uuid: "",
      deptId: "",
      detailTitle: "视频审核",
      CUFlag: false,
      activities: [],
      isAudit: false,
      auditScheduleAttr: [],
      currentDepIndex: 0,
      searchName: "",
      userList: [],
      isExpired: 0,
      props: {
        label: "name",
        children: "children"
      },

      rules: {
        auditSchedule: [{ required: true, message: "请选择审核意见" }],
        auditUserId: [
          { required: true, message: "请选择转交人", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    auditScheduleChange() {
      if (this.ruleForm.auditSchedule) {
        this.ruleForm.auditUserId = "";
        this.ruleForm.auditUserName = "";
        this.ruleForm.auditContent = "";
      }
    },
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (res.code !== 0) return;
        if (param === "AUDIT_SCHEDULE") {
          this.auditScheduleAttr = res.data.slice(1, 4);
        }
      });
    },
    // 获取审核列表
    getAuditHistoryList(uuid) {
      auditHistoryList(uuid).then(res => {
        if (res && res.code == 0) {
          let dataArray = res.data;
          if (dataArray != null && dataArray.length > 0) {
            for (var i = 0; i < dataArray.length; i++) {
              if (
                i != dataArray.length - 1 ||
                (i == dataArray.length - 1 &&
                  dataArray[i].auditSchedule != null)
              ) {
                dataArray[i].icon = "el-icon-success";
                dataArray[i].color = "#3A85FF";
              }
              dataArray[i].size = "large";
            }
            this.activities = dataArray;
            this.uuid = this.activities[this.activities.length - 1].uuid;
          }
        }
      });
    },
    // 关闭
    closeFrom() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["rForm"].resetFields();
    },
    // 确定
    updateForm() {
      this.$refs["rForm"].validate(valid => {
        if (valid) {
          if ( this.ruleForm.auditSchedule == 2 &&  this.isExpired) {
            this.$confirm('该视频已过期，请先修改有效期后再上线', '系统提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning'
            })
          } else {
            auditHistoryUpdate(
              Object.assign({ uuid: this.uuid }, this.ruleForm)
            ).then(res => {
              this.$message.success(res.msg);
              this.$emit("search", "");
            });
            this.closeFrom();
          }

        }
      });
    },
    selectAuditor() {
      Bus.$emit("video_audit_selectAuditor", this.deptId);
    },
    // 搜索过滤部门树
    searchUser(val) {
      this.$refs.tree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    templateCheckChange(data, checked) {
      if (checked) {
        this.$refs["tree"].setCheckedKeys([data.id]);
      }
    }
  },
  created() {
    let _this = this;
    _this.getSysParam("AUDIT_SCHEDULE");
    Bus.$on("video_audit_details", function (item) {
      _this.CUFlag = true;
      _this.getAuditHistoryList(item.uuid);
      _this.isAudit = item.isAudit;
      _this.deptId = item.videoDeptId;
      _this.isExpired = item.isExpired;
    });

    Bus.$on("video_audit_didSelectAuditor", auditor => {
      _this.ruleForm.auditUserId = auditor.id;
      _this.ruleForm.auditUserName = auditor.name;
    });
  }
};
</script>

<style lang="scss" scoped>
.button-dept {
  margin-left: 10px;
}
</style>
